
import React from 'react';
import { XCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const SubscriptionCancelled: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="max-w-md mx-auto text-center py-16 px-4">
      <XCircle className="w-16 h-16 text-gray-400 mx-auto mb-6" />
      <h1 className="text-2xl font-bold mb-4">Subscription Cancelled</h1>
      <p className="text-gray-600 mb-8">
        Your subscription process was cancelled. No charges have been made to your account.
        If you have any questions or need assistance, please contact our support team.
      </p>
      <div className="flex flex-col sm:flex-row gap-4">
        <Button onClick={() => navigate('/')} variant="outline" className="flex-1">
          Return Home
        </Button>
        <Button onClick={() => navigate('/pricing')} className="flex-1">
          View Plans Again
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionCancelled;
